import { render, staticRenderFns } from "./covenant_chart.vue?vue&type=template&id=364079f4&"
import script from "./covenant_chart.vue?vue&type=script&lang=js&"
export * from "./covenant_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports